<div class="container-fluid breadcrumbContainer-bac">
  <div class="container">
    <div class="row">
      <div class="col-md-10 col-ms-10 col-xs-8">
        <img class="icon-LogoIcon"
          [ngStyle]="{'float':currentLang == 'ar'  ? 'right' : 'left' ,'margin-right':currentLang == 'ar'  ? '0' : '15px' }"
          src="../../../assets/img/png-icon/icon-LogoIconp22.png" />
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" *ngFor="let item of breadcrumbItems">
              <a [routerLink]="item.link + item.params" routerLinkActive="router-link-active">
                {{item.title}}
              </a>
            </li>
          </ol>
        </nav>
      </div>
      <!-- <div class="col-md-2 col-ms-2 col-xs-4">
        <div class="icons">
          <ul class="list-inline icons-list">
            <li class="list-inline-item" (click)="print()">
              <i class="fas fa-print" style="color: #fff;font-size: 1.5em;"></i>
            </li>
            <li class="list-inline-item" data-toggle="modal" data-target="#sharePopup">
              <i class="fas fa-envelope-open-text" style="color: #fff;font-size: 1.5em;"></i>
            </li>
            <li class="list-inline-item" (click)="createBookmark()">
              <i class="fas fa-star" style="color: #fff;font-size: 1.5em;"></i>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</div>



<!-- Modal -->
<div class="modal fade" id="sharePopup" tabindex="-1" role="dialog" aria-labelledby="sharePopupTitle"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="">


        <div id="SendToFriendBox" class="centeredSendToFriend" style="display: block;">


          <span class="close" data-dismiss="modal" aria-label="Close" id="dismiss"><img
              src="./../../../assets/img/orangeClose.svg" class="fallback-png" alt=""></span>



          <!-- Content Start -->
          <section class="section-SendFriend-Form">
            <div class="row header">
              <div class="col-7 title">
                <h3>
                  &nbsp;إرسال الى صديق
                </h3>
              </div>
              <div class="col-5 title">
                <a class="logo pull-left" href="/">
                  <img src="./../../../assets/img/Logo.svg" alt="">
                </a>
              </div>
            </div>


            <form [formGroup]="form" class="Register-forms">

              <div class="form-group">
                <label><span>البريد الإكتروني<span class="StarValidtar">*</span></span></label>
                <input type="text" class="form-control" name="email" formControlName="email" required ngModal>
                <div class="errors"
                  *ngIf="form.controls.email.status == 'INVALID' && (form.controls.email.touched || form.controls.email.dirty || formSubmitted)">
                  <small *ngIf="form.controls.email.errors.required" class="text-danger">
                    حقل مطلوب
                  </small>
                  <!-- <small *ngIf="form.controls.email.errors.required" class="text-danger">
                    البريد الالكترونى غير صحيح
                  </small> -->
                </div>
              </div>
              <div class="form-group">
                <label><span>البريد الإكتروني للصديق<span class="StarValidtar">*</span></span></label>
                <input type="text" class="form-control" name="emailTo" formControlName="emailTo" required>
                <div class="errors"
                  *ngIf="form.controls.emailTo.status == 'INVALID' && (form.controls.emailTo.touched || form.controls.emailTo.dirty || formSubmitted)">
                  <small *ngIf="form.controls.emailTo.errors.required" class="text-danger">
                    حقل مطلوب
                  </small>
                  <!-- <small *ngIf="form.controls.emailTo.errors.required" class="text-danger">
                    البريد الالكترونى غير صحيح
                  </small> -->
                </div>
              </div>
              <div class="form-group">
                <label><span>التعليق<span class="StarValidtar">*</span></span></label>
                <textarea rows="5" cols="20" class="form-control" name="comment" formControlName="comment"
                  required></textarea>

                <div class="errors"
                  *ngIf="form.controls.comment.status == 'INVALID' && (form.controls.comment.touched || form.controls.comment.dirty || formSubmitted)">
                  <small *ngIf="form.controls.comment.errors.required" class="text-danger">
                    حقل مطلوب
                  </small>
                </div>
              </div>






            </form>




          </section>


          <div>
            <input type="submit" value="ارسال" class="btn" style="margin: 0px;" (click)="share()">
          </div>


        </div>



      </div>

    </div>
  </div>
</div>